import React from 'react';
import HomeNew from './HomeNew';

const Home = () => {
  return <HomeNew />;
};

export default Home;
